import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MACHINES, ENTREPRISE } from '../data/site';

const encode = (data) =>
  Object.keys(data)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
    .join('&');

const champ =
  'w-full bg-white border-2 border-nuit/15 rounded-[3px] px-4 py-3 text-[16px] ' +
  'focus:border-jaune focus:outline-none transition-colors placeholder:text-beton/70';
const label = 'block font-cond uppercase font-semibold tracking-[0.09em] text-[13.5px] text-nuit/70 mb-1.5';

export default function Formulaire() {
  const [etat, setEtat] = useState('pret');
  const [valeurs, setValeurs] = useState({
    nom: '', societe: '', email: '', telephone: '',
    machine: '', chauffeur: 'Sans chauffeur', dates: '', chantier: '', acces: '', message: '',
    consentement: '', 'societe-web': '',
  });

  const maj = (e) =>
    setValeurs((v) => ({
      ...v,
      [e.target.name]: e.target.type === 'checkbox' ? (e.target.checked ? 'oui' : '') : e.target.value,
    }));

  const envoyer = (e) => {
    e.preventDefault();
    setEtat('envoi');
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'devis', ...valeurs }),
    })
      .then(() => setEtat('ok'))
      .catch(() => setEtat('erreur'));
  };

  if (etat === 'ok') {
    return (
      <div className="carte p-8 border-l-4 border-l-jaune">
        <h3 className="font-display uppercase text-[26px] text-nuit">Demande bien reçue</h3>
        <p className="mt-3 text-nuit/75">
          On revient vers vous en quelques heures avec la machine qui convient et son tarif.
          Si votre chantier démarre demain, appelez-nous directement, c'est plus rapide.
        </p>
        <p className="mt-4 text-[14.5px] text-beton">
          Vous pouvez à tout moment demander l'accès, la rectification ou la suppression
          des informations transmises en écrivant à {ENTREPRISE.email}.
        </p>
      </div>
    );
  }

  return (
    <form
      name="devis"
      method="POST"
      data-netlify="true"
      netlify-honeypot="societe-web"
      onSubmit={envoyer}
      className="carte p-6 sm:p-8"
    >
      <input type="hidden" name="form-name" value="devis" />
      <p className="hidden">
        <label>
          Ne pas remplir
          <input name="societe-web" value={valeurs['societe-web']} onChange={maj} />
        </label>
      </p>

      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className={label} htmlFor="nom">Votre nom *</label>
          <input id="nom" name="nom" required value={valeurs.nom} onChange={maj} className={champ} autoComplete="name" />
        </div>
        <div>
          <label className={label} htmlFor="societe">Société *</label>
          <input id="societe" name="societe" required value={valeurs.societe} onChange={maj} className={champ} autoComplete="organization" />
        </div>
        <div>
          <label className={label} htmlFor="email">Email *</label>
          <input id="email" name="email" type="email" required value={valeurs.email} onChange={maj} className={champ} autoComplete="email" />
        </div>
        <div>
          <label className={label} htmlFor="telephone">Téléphone *</label>
          <input id="telephone" name="telephone" type="tel" required value={valeurs.telephone} onChange={maj} className={champ} autoComplete="tel" />
        </div>
        <div>
          <label className={label} htmlFor="machine">Machine souhaitée</label>
          <select id="machine" name="machine" value={valeurs.machine} onChange={maj} className={champ}>
            <option value="">Je ne sais pas encore, conseillez-moi</option>
            {MACHINES.map((m) => (
              <option key={m.slug} value={m.nom}>{m.nom}, {m.type.toLowerCase()}</option>
            ))}
            <option value="Accessoires">Accessoires seuls (BRH, pince de tri, godets)</option>
          </select>
        </div>
        <div>
          <label className={label} htmlFor="chauffeur">Avec ou sans chauffeur</label>
          <select id="chauffeur" name="chauffeur" value={valeurs.chauffeur} onChange={maj} className={champ}>
            <option>Sans chauffeur</option>
            <option>Avec chauffeur</option>
            <option>À voir avec vous</option>
          </select>
        </div>
        <div>
          <label className={label} htmlFor="dates">Dates de location</label>
          <input id="dates" name="dates" placeholder="Ex. du 12 au 16 septembre" value={valeurs.dates} onChange={maj} className={champ} />
        </div>
        <div>
          <label className={label} htmlFor="chantier">Commune du chantier</label>
          <input id="chantier" name="chantier" placeholder="Ex. Créteil" value={valeurs.chantier} onChange={maj} className={champ} />
        </div>
        <div className="sm:col-span-2">
          <label className={label} htmlFor="acces">Largeur et nature de l'accès</label>
          <input
            id="acces" name="acces"
            placeholder="Ex. portail de 1,60 m, terrain en pente, sol meuble"
            value={valeurs.acces} onChange={maj} className={champ}
          />
          <p className="mt-1.5 text-[14px] text-beton">
            C'est l'information qui nous permet de vous dire tout de suite quelle machine passe chez vous.
          </p>
        </div>
        <div className="sm:col-span-2">
          <label className={label} htmlFor="message">Votre chantier en deux mots</label>
          <textarea id="message" name="message" rows="4" value={valeurs.message} onChange={maj} className={champ} />
        </div>
      </div>

      {etat === 'erreur' && (
        <p className="mt-5 text-[15px] text-orange font-semibold">
          L'envoi n'a pas fonctionné. Écrivez-nous directement à contact@bati-select.fr ou appelez le 06 01 24 47 24.
        </p>
      )}

      <div className="mt-7 border-t border-nuit/10 pt-6">
        <label htmlFor="consentement" className="flex gap-3 items-start cursor-pointer">
          <input
            id="consentement"
            name="consentement"
            type="checkbox"
            required
            checked={valeurs.consentement === 'oui'}
            onChange={maj}
            className="mt-1 w-5 h-5 shrink-0 accent-[#F5B301] cursor-pointer"
          />
          <span className="text-[15px] text-nuit/85">
            J'accepte que {ENTREPRISE.nom} utilise les informations ci-dessus pour traiter
            ma demande de devis et me recontacter. *
          </span>
        </label>

        <p className="mt-4 text-[13.5px] text-beton leading-relaxed">
          Les champs marqués d'une étoile sont obligatoires. Le responsable de traitement est{' '}
          {ENTREPRISE.nom}, {ENTREPRISE.adresse}, {ENTREPRISE.codePostal} {ENTREPRISE.ville}.
          Vos données servent uniquement à établir votre devis et à assurer le suivi
          commercial qui en découle. Elles sont conservées trois ans à compter de notre
          dernier échange, ne sont ni vendues ni cédées, et ne sont accessibles qu'à notre
          équipe et à notre hébergeur Netlify, qui achemine le formulaire. Vous disposez
          d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition
          et de portabilité, que vous pouvez exercer à {ENTREPRISE.email}, ainsi que du
          droit d'introduire une réclamation auprès de la CNIL.{' '}
          <Link to="/confidentialite" className="text-bleu font-semibold underline underline-offset-2">
            Politique de confidentialité
          </Link>
          .
        </p>

        <button type="submit" disabled={etat === 'envoi'} className="btn-jaune mt-6 w-full sm:w-auto disabled:opacity-60">
          {etat === 'envoi' ? 'Envoi en cours...' : 'Envoyer ma demande'}
        </button>
      </div>
    </form>
  );
}
